export default __webpack_public_path__ + "static/shopping-centre-6-ce1053b876c7a5da8d05dfedde122e9a.jpg";